import axios from "axios";
import { liveURL } from "../../const/constants";

const MAIN_URL = `${liveURL}/classform`;

export async function getFields() {
  return axios.get(`${MAIN_URL}/fields`).then((res) => {
    return res.data;
  });
}

export async function submitForm(data) {
  return axios.post(`${MAIN_URL}/submit`, data).then((res) => {
    return res.data;
  });
}
